// ============================================================================
// CANCUN100 — Agenda.js  (APP 2/13 · Comisiones 2.0: agenda del agente · APP 2/19: ya sin pestaña propia)
// ----------------------------------------------------------------------------
// Desde APP 2/19 los servicios del agente se ven incrustados en cada día de Horarios (HorariosTab recibe eventos y
// balances). Aquí quedan los cálculos: eventos por folio (primer servicio = llegada) y el recordatorio de UN DÍA
// ANTES del primer servicio (banda arriba del panel). Solo lee.
// ============================================================================
import { itemsDe, itemVivo, num } from './contabilidadV3';

export const hoyISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
export const sumarDias = (iso, n) => { const d = new Date(iso + 'T12:00:00'); d.setDate(d.getDate() + n); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
const fechaItem = (it) => String(it.hotel_checkin || it.fecha_actividad || it.fecha || '').slice(0, 10);

// Eventos por folio: primer servicio (llegada) y todos los servicios con fecha.
export const eventosDe = (ventas) => {
  const out = [];
  (ventas || []).forEach((v) => {
    if (v.cancelado || v.estado === 'eliminado' || v.es_vigente === false || v.estado === 'borrador') return;
    const its = itemsDe({ servicios_detalle: v.cupon_items ?? v.servicios_detalle }).filter(itemVivo).filter((it) => fechaItem(it));
    if (!its.length) return;
    const primera = its.map(fechaItem).sort()[0];
    its.forEach((it) => out.push({ fecha: fechaItem(it), folio: v.folio, cliente: v.cliente || v.nombre, reserva_id: v.id, tipo: it.tipo_item, nombre: it.nombre, pickup: it.hotel || '', esPrimero: fechaItem(it) === primera, pago_balance: v.pago_balance || '' }));
  });
  return out.sort((a, b) => (a.fecha < b.fecha ? -1 : a.fecha > b.fecha ? 1 : 0));
};
// Recordatorio: folios cuyo PRIMER servicio es mañana (y su balance BR/BT por cobrar, si lo hay).
export const recordatoriosManana = (ventas, balances) => {
  const man = sumarDias(hoyISO(), 1);
  const ev = eventosDe(ventas).filter((e) => e.esPrimero && e.fecha === man);
  const vistos = new Set(); const out = [];
  ev.forEach((e) => { if (vistos.has(e.folio)) return; vistos.add(e.folio); const b = (balances || []).find((x) => x.reserva_id === e.reserva_id && num(x.pendiente) > 0 && ['BR', 'BT'].includes(String(x.pago_balance || '').toUpperCase())); out.push({ ...e, balance: b ? num(b.pendiente) : 0, balance_tipo: b ? b.pago_balance : '' }); });
  return out;
};
